var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"uk-button",class:_vm.className,attrs:{"disabled":_vm.shouldDisable,"type":"submit"}},[(!_vm.isSubmitting)?_c('span',[_vm._v(_vm._s(_vm.label))]):_c('span',{attrs:{"uk-spinner":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }